module.exports = __webpack_public_path__ + "14d24903c3be4a504dd14aa372b4f85f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-5.png
// module id = 1513
// module chunks = 0